module.exports = __webpack_public_path__ + "media/registration/permanent-resident-icon-a035672d.svg";